import * as d3 from 'd3';
import { flatten } from 'lodash';
export function prepareData(chartData, dataSetProps) {
    const dayColumn = chartData.columnDefinitions[0];
    const valueColumn = chartData.columnDefinitions[1];
    const graphDataSets = chartData.dataSets.map((chartDataSet) => {
        const props = dataSetProps?.[chartDataSet.id] ?? {};
        const graphRows = chartDataSet.rows.map((row) => ({
            color: props.color ?? 'black',
            day: new Date(row[dayColumn.id]),
            value: row[valueColumn.id],
            dataSet: undefined,
        }));
        const graphDataSet = {
            ...chartDataSet,
            name: props.label ?? chartDataSet.id,
            color: props.color ?? 'black',
            rows: graphRows,
        };
        graphDataSet.rows.forEach((row) => (row.dataSet = graphDataSet));
        return graphDataSet;
    });
    const allRows = flatten(graphDataSets.map((graphDataSet) => graphDataSet.rows));
    return {
        dataSets: graphDataSets,
        allRows: allRows,
        xDomain: d3.extent(allRows, (d) => d.day),
        yDomain: [0, d3.max(allRows, (d) => d.value)],
    };
}
